import React from "react";
import UserAddModal from "./Components/UserAddModal";

const UserAddPage = () => {
  return <UserAddModal />;
};

export default UserAddPage;
